import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, IconButton, TableCell, Tooltip } from "@material-ui/core";
import { Edit, PlayArrow, Stop } from "@material-ui/icons";
import { DeleteButtonWithModal } from "frontend/src/ui/delete-button-with-modal";
import { If } from "frontend/src/ui/if";
import { TrackRow } from "frontend/src/ui/track-row";
import { paths } from "frontend/src/pages/paths/index";
import { useDeleteTimetable } from "frontend/src/domain/timetables/actions";
import { useIsTimetableSelectedForPlayer } from "frontend/src/domain/player-track-queue";
export var Timetable = function (_a) {
    var id = _a.id, title = _a.title, scheduleDays = _a.scheduleDays, scheduleTime = _a.scheduleTime, usedBy = _a.usedBy, onPlay = _a.onPlay, index = _a.index;
    var selected = useIsTimetableSelectedForPlayer(id);
    var removeAction = useDeleteTimetable();
    var remove = function () { return removeAction.run(id); };
    var play = function () { return onPlay({ selected: selected, index: index }); };
    return (React.createElement(TrackRow, { isSelectedForPlayer: selected },
        React.createElement(TableCell, null, title),
        React.createElement(TableCell, null, scheduleDays),
        React.createElement(TableCell, null, scheduleTime),
        React.createElement(TableCell, null,
            React.createElement(Button, { type: "button", color: "primary", variant: selected ? "contained" : "outlined", startIcon: selected ? (React.createElement(Stop, { fontSize: "small" })) : (React.createElement(PlayArrow, { fontSize: "small" })), onClick: play }, selected ? "Остановить" : "Активировать")),
        React.createElement(TableCell, null,
            React.createElement(Tooltip, { title: "Редактировать" },
                React.createElement(RouterLink, { to: paths.business.owner.timetables.edit(id) },
                    React.createElement(IconButton, { size: "small" },
                        React.createElement(Edit, null))))),
        React.createElement(TableCell, null,
            React.createElement(If, { condition: usedBy === 0 },
                " ",
                React.createElement(DeleteButtonWithModal, { onDelete: remove, message: "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \"" + title + "\"?" })))));
};
